import {CookieOptionType} from '../../../skin/frontend/base/default/js/aiti/core/cookiesConsent/cookieOption';

(function() {

    if (!AitiCookiesConsent.getOption(CookieOptionType.ANALYTICS).isAllowed()) {
        return;
    }

    AitiCore.getCookies().set('aiti_b2u', '[]');

    (function(event, name, callback){ ((window[window.dataLayerVariableName]) as unknown as any[]).push(arguments); })('event', 'optimize.callback', {
        callback: function(variantId, experimentId) {
            let experiments = [];

            try {
                experiments = JSON.parse(AitiCore.getCookies().get('aiti_b2u') as string);
            } catch (e) {
            }

            experiments.push({
                experimentId: experimentId,
                variantId: variantId
            });

            AitiCore.getCookies().set('aiti_b2u', JSON.stringify(experiments));
        }
    });
})();

declare global {
    interface Window {
        dataLayerVariableName: any;
    }
}
